<template>
  <KeypadSetting v-bind="$attrs" :validator="validate">
    <template #BinSelectionInput>
      <slot name="BinSelectionInput"></slot>
    </template>
  </KeypadSetting>
</template>

<script>
import KeypadSetting from "./KeypadSetting.vue";

export default {
  components: { KeypadSetting },
  methods: {
    validate(ipString) {
      let parts = ipString.split(".");

      if (parts.length != 4) 
        return false;
      else if (parts.some(part => isNaN(part)))
        return false;
      else if (parts.some(part => part == ""))
        return false;
      else if (parts.some(part => parseInt(part) > 255))
        return false;
      else
        return true;
    }
  }
}
</script>